var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c("b-overlay", {
        attrs: {
          show: _vm.showOverlay,
          "no-wrap": "",
          "spinner-type": "grow",
          opacity: ".40",
          "spinner-variant": "primary",
          "z-index": "99999999",
        },
      }),
      _vm._v(" "),
      _c("b-col", { attrs: { md: "12" } }, [
        _c("div", { staticClass: "title-block" }, [
          _c("h2", { staticClass: "title mt-4" }, [
            _c("span", {
              domProps: {
                textContent: _vm._s(_vm.$t("consulta-solicitudes.title")),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "sparkline bar",
              attrs: { "data-type": "bar" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { sm: "12", lg: "12" } },
        [
          _c("b-alert", {
            attrs: { show: "", variant: "warning" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("consulta-solicitudes.alert.administrativo")
              ),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { sm: "12", lg: "12" } },
        [
          _c("b-alert", {
            attrs: { show: "", variant: "info" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("consulta-solicitudes.alert.informativo")
              ),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { lg: "12" } },
        [_c("alerta", { ref: "alerta", attrs: { id: "alertSolicitud" } })],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { md: "12" } }, [
        _vm.validSolictud
          ? _c(
              "div",
              { staticClass: "table-responsive" },
              [
                _c("b-table", {
                  staticClass: "btn-custom-acciones docs-btn",
                  attrs: {
                    fields: _vm.fieldsRegistros,
                    items: _vm.solicitudes,
                    "current-page": _vm.currentPage,
                    "per-page": _vm.recordsPage,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "sort-direction": _vm.sortDirection,
                    stacked: "md",
                    "show-empty": "",
                    small: "",
                    striped: "",
                    borderless: "",
                    outlined: "",
                    hover: "",
                    "sort-compare-options": {
                      numeric: true,
                      sensitivity: "base",
                    },
                    "head-variant": "light",
                    "empty-filtered-text": _vm.$t(
                      "consulta-solicitudes.alert.emptyFilter"
                    ),
                    "empty-text": _vm.$t("consulta-solicitudes.alert.empty"),
                  },
                  on: {
                    "update:sortBy": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function ($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": function ($event) {
                      _vm.sortDesc = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(acciones)",
                        fn: function (row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  title: _vm.$t("entity.action.edit"),
                                  size: "sm",
                                  variant: row.item.reseteado
                                    ? "outline-danger"
                                    : "outline-primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.prepareSolicitud(
                                      row.item,
                                      row.item.idRegistro
                                    )
                                  },
                                },
                              },
                              [_c("span", { staticClass: "icon-editar" })]
                            ),
                            _vm._v(" "),
                            row.item?.comentarioEstatus
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "entity.action.ver-comentario"
                                      ),
                                      size: "sm",
                                      variant: "outline-primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.consultaComentario(row.item)
                                      },
                                    },
                                  },
                                  [_c("span", { staticClass: "icon-mensaje" })]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4050232675
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { md: "6", "offset-md": "3" } },
        [
          _vm.solicitudes.length > _vm.recordsPage
            ? _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.solicitudes.length,
                  "per-page": _vm.recordsPage,
                  "aria-controls": "my-table",
                  align: "fill",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalComentario",
            title: _vm.$t("solicitud-moral.comentario.title"),
            size: "lg",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ hide }) {
                return [
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              return hide()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("entity.action.cancel")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-form-textarea", {
                    attrs: { id: "motivo-id", rows: "3", readonly: "true" },
                    model: {
                      value: _vm.comentario,
                      callback: function ($$v) {
                        _vm.comentario = $$v
                      },
                      expression: "comentario",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }